import { Component, OnInit } from '@angular/core';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-login',
  imports: [AmplifyAuthenticatorModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  loading: boolean = true;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.checkAuthenticationStatus();
  }

  private async checkAuthenticationStatus(): Promise<void> {
    try {
      const user = await firstValueFrom(this.authService.getUser());
      if (user) {
        window.location.href = '/'; // Full page reload
      } else {
        this.redirectToLogin();
      }
    } catch (error) {
      this.redirectToLogin();
    } finally {
      this.loading = false;
    }
  }

  private redirectToLogin(): void {
    window.location.href = environment.loginUrl;
  }
}
